<template>
  <div id="app" ref="app">
    <PCNavbar />
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
import Home from '@/views/Home'
import PCNavbar from '@/components/navbar/index'
export default {
  name: 'App',
  components: {
    Home,
    PCNavbar,
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden; /* 防止水平滚动条 */
}

#app {
  width: 100%;
  min-height: 100vh;
}
@import url('./assets/css/icon.css');

/* 全局覆盖Element UI下拉菜单样式 - 确保导航栏子菜单正确显示1*/
.el-menu--popup {
  z-index: 1001 !important;
  background-color: rgba(0, 187, 238, 0.95) !important;
  border: none !important;
  border-radius: 4px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  min-width: 120px !important;
  margin-top: 0 !important;
  display: block !important; /* 确保子菜单显示 */
  transition: none !important; /* 移除所有过渡动画 */
  animation: none !important; /* 移除所有动画 */
  opacity: 1 !important; /* 确保子菜单可见 */
  visibility: visible !important; /* 确保子菜单可见 */
}

.el-menu--popup .el-menu-item {
  color: #fff !important;
  background-color: rgba(0, 187, 238, 0.95) !important;
  min-width: 120px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.el-menu--popup .el-menu-item:hover {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

.el-menu--popup .el-menu-item.is-active {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

.el-submenu__title {
  position: relative !important;
  color: #fff !important;
  height: 70px !important;
  line-height: 70px !important;
}

.el-submenu__title:hover {
  background-color: rgba(0, 187, 238, 0.9) !important;
  color: #fff !important;
}

.el-submenu.is-opened .el-submenu__title {
  background-color: rgba(0, 187, 238, 0.9) !important;
}

/* 确保所有子菜单相关元素都有正确的样式 */
.el-submenu .el-menu-item {
  color: #fff !important;
}

.el-submenu__icon-arrow {
  margin-top: -5px !important;
}

/* 确保子菜单能够正确显示和交互111 */
.el-submenu__title {
  cursor: pointer !important;
}

.el-submenu .el-menu {
  overflow: visible !important;
}

/* 确保所有页面子菜单弹出框都有正确的蓝色背景 */
.el-menu--popup,
.el-menu--popup-bottom-start,
.el-menu--popup-bottom-end,
.el-menu--popup-top-start,
.el-menu--popup-top-end {
  background-color: rgba(0, 187, 238, 0.95) !important;
  border: none !important;
  border-radius: 4px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  z-index: 1001 !important;
  min-width: 120px !important;
  margin-top: 0 !important;
  transition: none !important; /* 移除所有过渡动画 */
  animation: none !important; /* 移除所有动画 */
  display: block !important; /* 确保子菜单显示 */
  opacity: 1 !important; /* 确保子菜单可见 */
  visibility: visible !important; /* 确保子菜单可见 */
  pointer-events: auto !important; /* 确保子菜单可以交互 */
}

.el-menu--popup .el-menu-item,
.el-menu--popup-bottom-start .el-menu-item,
.el-menu--popup-bottom-end .el-menu-item,
.el-menu--popup-top-start .el-menu-item,
.el-menu--popup-top-end .el-menu-item {
  color: #fff !important;
  background-color: rgba(0, 187, 238, 0.95) !important;
  min-width: 120px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.el-menu--popup .el-menu-item:hover,
.el-menu--popup-bottom-start .el-menu-item:hover,
.el-menu--popup-bottom-end .el-menu-item:hover,
.el-menu--popup-top-start .el-menu-item:hover,
.el-menu--popup-top-end .el-menu-item:hover {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

.el-menu--popup .el-menu-item.is-active,
.el-menu--popup-bottom-start .el-menu-item.is-active,
.el-menu--popup-bottom-end .el-menu-item.is-active,
.el-menu--popup-top-start .el-menu-item.is-active,
.el-menu--popup-top-end .el-menu-item.is-active {
  background-color: rgba(0, 187, 238, 1) !important;
  color: #fff !important;
}

/* 确保导航栏在所有页面都能正确显示 */
#app .navbar_wrap {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  height: 70px !important; /* 确保导航栏高度固定 */
}

/* 确保Element UI菜单组件保持正确大小 */
.el-menu--horizontal {
  height: 70px !important;
  line-height: 70px !important;
}

.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu > .el-submenu__title {
  height: 70px !important;
  line-height: 70px !important;
}

/* 防止View UI样式覆盖Element UI导航栏 */
.ivu-menu-horizontal {
  z-index: auto !important;
}

/* 确保有固定导航栏的页面容器为导航栏预留空间 */
.home-container {
  padding-top: 70px !important;
}

/* 确保滚动事件在所有页面都能正确触发 */
html, body {
  scroll-behavior: smooth;
}

/* 全局导航栏子菜单定位样式 - 确保所有导航组件的子菜单都能正确显示 */
.navbar-submenu {
  position: fixed !important;
  top: 70px !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  margin-top: 0 !important;
  z-index: 1001 !important;
}

.navbar-submenu .el-menu--popup {
  position: fixed !important;
  top: 70px !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  margin-top: 0 !important;
  z-index: 1001 !important;
}
</style>
